module.exports = __webpack_public_path__ + "img/science.ee923ebe.jpg";